import React from "react"
import { Box } from "@infotech/uikit-grid"
import { InputNumber } from "@infotech/uikit-input"

const InputNumberHOC = props => {
  const {
    meta: { error },
    input: { onChange, value, name },
    max,
    min,
  } = props
  return (
    <Box loose>
      <InputNumber
        style={{ width: `100%` }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        error={error}
        name={name}
        value={value}
        onChange={val => onChange(val)}
        max={max || Number.MAX_SAFE_INTEGER}
        min={min || 0}
      />
    </Box>
  )
}

export default InputNumberHOC
